import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RegisteredEmployeeDetailView } from '@iota/inh-core-v1-management-client';
import { Store } from '@ngrx/store';
import { map, Observable } from 'rxjs';
import { companyById } from 'src/app/store/reducer/company.reducer';
import { resolveCompanyUrl } from '../../utils';
import { Clipboard } from '@angular/cdk/clipboard';
import { CompanyEntity } from 'src/app/store/entity-models';

@Component({
    standalone: false,
    selector: 'app-employee-card',
    templateUrl: './employee-card.component.html',
    styleUrls: ['./employee-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployeeCardComponent implements OnInit {
    @Input() employee: RegisteredEmployeeDetailView;
    @Input() initials: string;
    @Input() displayAdditionalInfo = false;

    @Output() cardClicked = new EventEmitter<void>();

    showTooltip = false;
    showCheckedIcon = false;
    tooltipText = $localize`Copy number`;
    company: CompanyEntity;

    company$: Observable<CompanyEntity>;
    companyUrl$: Observable<string>;

    constructor(
        private store: Store,
        private clipboard: Clipboard,
        private destroyRef: DestroyRef
    ) {}

    ngOnInit() {
        this.company$ = this.store.select(companyById(this.employee?.companyId));
        this.companyUrl$ = this.company$.pipe(map((company) => resolveCompanyUrl(company)));
        this.company$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((company: CompanyEntity) => {
            this.company = company;
        });
    }

    showCompanyNumberToolTip() {
        this.showTooltip = true;
    }

    hideTooltip() {
        this.showTooltip = false;
    }

    copyCompanyNumber(company: CompanyEntity) {
        this.clipboard.copy(company.companyNumber);
        this.tooltipText = $localize`Copied`;
        this.showCheckedIcon = true;
        this.showTooltip = true;

        setTimeout(() => {
            this.tooltipText = $localize`Copy number`;
            this.showCheckedIcon = false;
            this.showTooltip = false;
        }, 2000);
    }
}
